/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_No_Eligible_JobsInputs */



/**
* | output |
* | --- |
* | "No eligible jobs selected." |
*
* @param {Batch_No_Eligible_JobsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_no_eligible_jobs = /** @type {((inputs?: Batch_No_Eligible_JobsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_No_Eligible_JobsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun poste admissible n'a été sélectionné.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Es wurden keine passenden Stellen ausgewählt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun posto di lavoro idoneo selezionato.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подходящих вакансий не отобрано.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se ha seleccionado ningún puesto que cumpla los requisitos.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未选择符合条件的职位。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("該当する求人は見つかりませんでした。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई भी योग्य पद चयनित नहीं हुआ।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhuma vaga elegível selecionada.")
	return /** @type {LocalizedString} */ ("No eligible jobs selected.")
});